import { useState, useEffect } from "react";

const WindowSizeDetector = () => {
	const isBrowser = typeof window !== "undefined";
	const [windowWidth, SetWindowSize] = useState(isBrowser && document.body.offsetWidth);

	useEffect(() => {
		const handleWindowResize = () => {
			SetWindowSize(isBrowser && document.body.offsetWidth);
		};
		window.addEventListener("resize", handleWindowResize);
		return () => isBrowser && window.removeEventListener("resize", handleWindowResize);
	}, [isBrowser]);

	return windowWidth;
};

export default WindowSizeDetector;
export { WindowSizeDetector };
